import React, { PropsWithChildren, HTMLProps } from 'react';
import cls from 'classnames/bind';

import styles from './Row.scss';

type Props = PropsWithChildren<
  {
    className?: string;
  } & HTMLProps<HTMLDivElement>
>;

const Row = (props: Props) => {
  const { children, className, ...restProps } = props;

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div className={cls(styles.row, className)} {...restProps}>
      {children}
    </div>
  );
};

export default Row;
